import { render, staticRenderFns } from "./product-alerts-container.vue?vue&type=template&id=178777cd&scoped=true"
import script from "./product-alerts-container.vue?vue&type=script&lang=js"
export * from "./product-alerts-container.vue?vue&type=script&lang=js"
import style0 from "./product-alerts-container.vue?vue&type=style&index=0&id=178777cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178777cd",
  null
  
)

export default component.exports